// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"738":"283bc1d7","966":"9f217daf"}[chunkId] + ".chunk.js");